<template>
  <div>
    <v-list>
      <bookmark-list />
      <v-list-item to="/books">
        <v-list-item-content>
          <v-list-item-title>Book mode</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/repos">
        <v-list-item-content>
          <v-list-item-title>Tree mode</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import BookmarkList from "@/components/BookmarkList";

export default {
  name: "Home",
  components: { BookmarkList }
};
</script>
